<form #balanceForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/balance']">Opening Balance</a> > Create</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(balanceForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>FY Code</mat-label>
            <mat-select #financial_year_element (openedChange)="onFinancialYearScroll($event)" [(value)]="selectedFinancialYear" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onFinancialYearKey($event)" matInput name="financial_year_list">
              <mat-option *ngFor="let fy of allFinancialYears" [value]="fy.id">{{ fy.fy_code }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Doctor</mat-label>
            <mat-select #doctor_id (openedChange)="onDoctorScroll($event)" [disabled]="isFormDisabled || disableDoctorSelection" [(value)]="selectedDoctor" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onDoctorKey($event)" matInput name="doctor_list">
              <mat-option *ngFor="let doctor of allDoctors" [value]="doctor.id">{{ doctor.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Opening Balance</mat-label>
            <input #opening_balance="ngModel" type="text" matInput name="opening_balance" [(ngModel)]="balance.opening_balance" required>
            <mat-error *ngIf="opening_balance.invalid && opening_balance.touched">Required</mat-error>
          </mat-form-field>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="balance" [recordId]="balance.id"></app-audit-log-viewer>
</form>
